<template>
    <section class="list-actus">
        <div class="container">

            <section class="filters">
                <ul class="filtre-taaf-rnn">
                    <li v-for="(item, index) in taxoEntities" :key="index">
                        <a href="" :class="{active: form.site === item.id}" @click.prevent="filtreSite(item.id)">
                            <span class="pastille" :class="item.slug"></span>
                            {{item.label}}
                        </a>
                    </li>
                </ul>
                <form action="" @submit.prevent="formSubmit()">
                    <div class="form-item word-search">
                        <span class="icon-arrow-right" @click="formSubmit()"></span>
                        <input type="text" name="word" id="word" placeholder="Recherche par mot-clés"
                               v-model="form.word">
                    </div>
                </form>

            </section>


            <div class="loader-wrap" v-if="loading">
                <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <transition-group
                    tag="div"
                    class="list-wrap"
                    v-bind:css="false"
                    v-on:before-enter="beforeEnter"
                    v-on:enter="enter"
            >
                <a :href="item.url" class="item"
                   :class="{focus: form.page === 1 && index === 0}"
                   :key="'key_'+index"
                   :data-index="index"
                   v-for="(item,index) in result">
                    <div class="img" :style="'background-image: url('+item.imgUrl+')'"></div>
                    <div class="description">
                        <h2 class="titre" v-html="getTitle(item, index)"></h2>
                        <div class="summary" v-html="getHtml(item, index)"></div>
                        <div class="footer-item">
                            <div :class="'bar '+item.type"></div>
                            <div class="date" v-html="item.date"></div>
                        </div>
                    </div>
                </a>
            </transition-group>
            <p v-if="result && result.length === 0" class="no-results">
                <slot name="no-results"></slot>
            </p>
            <div class="clearfix"></div>
            <pagination
                    v-if="!loading && showPagination"
                    :pagination="pagination"
                    :params="form"
                    :offset="2"
                    @paginate="formSubmit"></pagination>
        </div>
    </section>
</template>

<script>
    import $ from "jquery";
    import Ajax from "../../mixins/ajax"
    import Animation from "../../mixins/animation"
    import Scrolling from "../../libs/Scrolling"
    import {truncate} from "lodash";

    export default {
        mixins: [Ajax, Animation],
        props: ["current-site-id", "taxo-entities"],
        data() {
            return {
                result: null,
                loading: false,
                pagination: {},
                firstLoad: true,
                form: {
                    page: 1,
                    word: "",
                    site: ""
                }
            };
        },
        computed: {
            showPagination() {
                if ((this.pagination.current_page === this.pagination.last_page) && this.pagination.current_page === 1) {
                    return false
                } else {
                    return true
                }
            },
            breakpointDownXl() {
                return this.$root.breakpointDownXl;
            },
            breakpointDownLg() {
                return this.$root.breakpointDownLg;
            },
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
        },
        methods: {
            formSubmit(form) {
                this.loading = true;
                this.result = null;
                if (form) {
                    this.form = form;
                }
                if (!this.form.page) {
                    this.form.page = 1;
                }

                if (!this.firstLoad) {
                    Scrolling.scrollTo("section.list-actus", "easeOutCubic", 600, 0);

                }

                this.ajax("news", "getNews", {form: this.form}).always((data) => {

                    if (typeof data.result !== "undefined") {
                        this.loading = false;
                        this.result = data.result;
                        this.pagination = data.pagination;
                        this.firstLoad = false

                    } else {
                        console.log("error");
                    }
                });


            },
            filtreSite(site) {
                this.form.page = 1
                this.form.site = site
                this.formSubmit()
            },
            getTitle(item, index) {
                let length = 59

                return truncate(item.title, {
                    "length": length,
                    "omission": "..."
                })
            },
            getHtml(item, index) {
                let length = 150
                if (this.breakpointDownXl) {
                    length = 120
                }
                if (this.breakpointDownLg) {
                    length = 110
                }
                if (this.breakpointDownMd) {
                    length = 190
                }
                if (this.form.page === 1 && index === 0) {
                    length = 190
                }
                return truncate(item.summary_html, {
                    "length": length,
                    "omission": "..."
                })
            }
        },
        created() {
            this.animDelta = 100
        },
        mounted() {
            setTimeout(() => {
                if (this.currentSiteId === 2) {
                    this.form.site = "rnn";
                }
                this.formSubmit()
            }, 500)
        },
        destroyed() {
        }
    };
</script>
